export default __webpack_public_path__ + "static/media/image-about-mission-m.4f52d66b.webp";